module.exports = __webpack_public_path__ + "site/img/7.78237b2a.jpg";